import {isEqual} from '@yandex-delivery/utils'

import type {RouteProps} from '../model'

export const arePropsEqual = (prevProps: RouteProps, nextProps: RouteProps) => {
  return (
    prevProps.drawJams === nextProps.drawJams &&
    prevProps.onBoundsChange === nextProps.onBoundsChange &&
    isEqual(prevProps.points, nextProps.points) &&
    prevProps.style === nextProps.style
  )
}
